import { useState } from "react";
import { Input, InputGroup, InputProps, InputRightAddon } from "./index";
import { EyeIcon, EyeOffIcon } from "lucide-react";

export interface PasswordInputProps {
  inputProps?: InputProps;
  "data-testid"?: string;
}
export function PasswordInput(props: PasswordInputProps) {
  const [show, setShow] = useState(false);
  const testId = props["data-testid"] || "password-input";

  return (
    <InputGroup data-testid={testId}>
      <Input {...props.inputProps} type={show ? "text" : "password"} />
      <InputRightAddon>
        <button
          type="button"
          onClick={() => setShow((x) => !x)}
          data-testid="password-input-toggle"
        >
          {show ? (
            <EyeIcon className="mr-3 h-5 w-5 stroke-1" />
          ) : (
            <EyeOffIcon className="mr-3 h-5 w-5 stroke-1" />
          )}
        </button>
      </InputRightAddon>
    </InputGroup>
  );
}
